var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"impact e3d",attrs:{"id":"banner"}},[_c('div',{staticClass:"anim"}),_vm._v(" "),_c('div',{staticClass:"text-wrapper e3dlayer",style:({ transform: _vm.transform })},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('cover.content'))}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d008283","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cover.vue
// module id = null
// module chunks = 